<template>
  <div class="tax-invoice-request-display">
    <div class="card card-default mb-4">
      <h4 class="card-header">
        <i
          v-if="!taxInvoiceRequest.sent"
          class="fa fa-exclamation-triangle text-warning" />
          Reference: {{ taxInvoiceRequest.referenceNumber }}
      </h4>
      <div class="card-body">
        <p
          class="alert alert-warning"
          v-if="!taxInvoiceRequest.sent">
          Tax Invoice Request Not Sent
        </p>
        <h5 class="mb-1">
          <span v-if="taxInvoiceRequest.propertyAddress">
            {{ taxInvoiceRequest.propertyAddress }}
          </span>
          <em v-else>No data available</em>
        </h5>
        <p class="text-muted">
          {{ taxInvoiceRequest.StaffMember.fullName }} - <i class="far fa-clock fa-fw" /> {{ taxInvoiceRequest.createdAt | date_time_format }}
        </p>
        <p>
          <strong>Files:</strong>
        </p>
        <ul>
          <li v-if="taxInvoiceRequest.InvoiceRequestPdf">
            <download-input
              :options="{ label: taxInvoiceRequest.referenceNumber, permalink: 'downloadFile'}"
              :value="{ objectKey: taxInvoiceRequest.InvoiceRequestPdf.objectKey }" />
          </li>
          <li v-if="taxInvoiceRequest.ContractorsInvoice">
            <download-input
              :options="{ label: taxInvoiceRequest.ContractorsInvoice.fileName, permalink: 'downloadFile'}"
              :value="{ objectKey: taxInvoiceRequest.ContractorsInvoice.objectKey }" />
          </li>
          <li v-if="taxInvoiceRequest.Quote">
            <download-input
              :options="{ label: taxInvoiceRequest.Quote.fileName, permalink: 'downloadFile'}"
              :value="{ objectKey: taxInvoiceRequest.Quote.objectKey }" />
          </li>
          <li v-if="taxInvoiceRequest.WorkOrder">
            <download-input
              :options="{ label: taxInvoiceRequest.WorkOrder.fileName, permalink: 'downloadFile'}"
              :value="{ objectKey: taxInvoiceRequest.WorkOrder.objectKey }" />
          </li>
          <li
            v-for="attachment in taxInvoiceRequest.Attachments"
            :key="attachment.uuid">
            <download-input
              :options="{ label: attachment.fileName, permalink: 'downloadFile'}"
              :value="{ objectKey: attachment.objectKey }" />
          </li>
        </ul>
        <template v-if="taxInvoiceRequest.UploadedInvoice">
          <p>
            <strong>Uploaded Invoice:</strong>
          </p>
          <ul>
            <li>
              <download-input
              :options="{ label: taxInvoiceRequest.UploadedInvoice.fileName, permalink: 'downloadFile'}"
              :value="{ objectKey: taxInvoiceRequest.UploadedInvoice.objectKey }" />
            </li>
          </ul>
        </template>
      </div>
      <div class="card-footer">
        <button class="my-1 btn btn-success" @click="upload()">
          <i class="fa fa-upload"></i> Upload Invoice
        </button>
        <button
          class="my-1 btn btn-lime"
          @click="send()">
          <i class="far fa-fw fa-paper-plane" /> Send
        </button>
        <button
          :class="taxInvoiceRequest.completed ? 'my-1 btn btn-secondary' : 'my-1 btn btn-success'"
          @click="complete()">
          <i class="fas fa-check" /> {{ taxInvoiceRequest.completed ? 'completed' : 'complete' }}
        </button>
        <router-link
          :to="'/tax-invoice-requests/edit/' + taxInvoiceRequest.uuid "
          class="my-1 btn btn-warning">
          <i class="fa fa-fw fa-edit" /> Edit
        </router-link>
        <button
          v-if="$user.administrator"
          @click="del()"
          class="my-1 btn btn-danger">
          <i class="fa fa-fw fa-trash" /> Delete
        </button>
        <button
          class="my-1 btn btn-lime"
          @click="duplicate()">
          <i class="far fa-fw fa-copy" /> Duplicate
        </button>
        </div>
    </div>
  </div>
</template>


<script>
  import {
    DUPLICATE_TAX_INVOICE_REQUEST,
    DELETE_TAX_INVOICE_REQUEST,
    SEND_TAX_INVOICE_REQUEST,
    COMPLETE_TAX_INVOICE_REQUEST,
    UPLOAD_INVOICE
  } from '@/vuex/types'
  import DownloadInput from '@/components/inputs/DownloadInput'
  export default {
    name: 'TaxInvoiceRequestDisplay',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    components: {
      DownloadInput
    },
    computed: {
      taxInvoiceRequest () {
        return {
          ...this.object
        }
      }
    },
    methods: {
      async upload () {
        await this.$store.dispatch(UPLOAD_INVOICE, this.taxInvoiceRequest.uuid)
      },
      async send () {
        await this.$store.dispatch(SEND_TAX_INVOICE_REQUEST, this.taxInvoiceRequest.uuid)
      },
      async del () {
        await this.$store.dispatch(DELETE_TAX_INVOICE_REQUEST, this.taxInvoiceRequest.uuid)
      },
      async duplicate () {
        await this.$store.dispatch(DUPLICATE_TAX_INVOICE_REQUEST, this.taxInvoiceRequest.uuid)
      },
      async complete () {
        await this.$store.dispatch(COMPLETE_TAX_INVOICE_REQUEST, this.taxInvoiceRequest.uuid)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/cards/TaxInvoiceRequest.vue